<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" :title="title" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-cell-group>
				<van-field readonly clickable :value="subjectMatter" name="subjectMatter" label="标的物" placeholder="请选择标的物"
					:rules="[{ required: true, message: '' }]" @click="showSubjectMatterPicker = true" style="left: 5px;" />
				<van-popup v-model="showSubjectMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="subjectMatterList" value-key="displayName"
						@confirm="selSubjectMatter" @cancel="showSubjectMatterPicker = false" />
				</van-popup>
			</van-cell-group>
			<van-cell-group>
				<van-field readonly clickable :value="majorMatter" name="majorMatter" label="专业" placeholder="请选择专业"
					:rules="[{ required: true, message: '' }]" @click="showMajorMatterPicker = true" style="left: 5px;" />
				<van-popup v-model="showMajorMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="majorMatterList" value-key="displayName" @confirm="selMajorMatter"
						@cancel="showMajorMatterPicker = false" />
				</van-popup>
			</van-cell-group>
			<van-row class="uploadBoxTop" gutter="20">
				<van-col span="6">
					<van-uploader v-model="fileList" max-count="1" :after-read="uploadFile" :before-delete="delFile"
						accept="image/*" />
				</van-col>
				<van-col span="18">
					<van-field v-model="photoContent" class="photoDesc" type="textarea" autosize name="photoContent"
						placeholder="请输入描述信息~" />
				</van-col>
			</van-row>
			<van-row class="uploadBoxBottom" gutter="20">
				<van-col span="24">
					<van-field readonly clickable :value="date" name="date" label="日期" placeholder="请选择日期"
						:rules="[{ required: true, message: '' }]" @click="showDateCalendar = true" />
					<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
						@confirm="selDateCalendar" />
				</van-col>
			</van-row>
			<van-button round type="info" class="saveButton" native-type="submit">提交</van-button>
		</van-form>
	</div>
</template>
<script>
import ImageCompressor from '@/utils/ImageCompressor'
import common from '../../utils/common';
import { Notify } from 'vant';
import { getNowDate } from "../../utils/date"
import { upload } from '../../api/commonApi'
import { save } from '../../api/photo'
import { getSubjectDropDown, getMajorList } from '../../api/commonApi'

export default {
	name: 'photoUpload',
	data() {
		return {
			title: "",
			photoType: "",
			date: "",
			minDate: new Date(new Date().getFullYear() - 2, 0, 1, 0, 0, 0),
			maxDate: new Date(new Date().getFullYear() + 2, 11, 31, 23, 59, 59),
			photoContent: "",
			showDateCalendar: false,
			fileInfoList: [],
			fileList: [],
			project: {},
			addPhotoList: [],
			subjectMatterList: [
			],
			subjectMatter: "",
			subjectMatterId: "",
			showSubjectMatterPicker: false,
			majorMatter: "",
			majorMatterId: "",
			majorMatterList: [
			],
			showMajorMatterPicker: false,
			businessType: "94", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
			fileKey: "0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")
		}
	},
	mounted() {
		this.project = common.getProject();
		this.doGetSubjectDropDown()
		this.doGetMajorDropDown()
		if (this.project == null || this.project == undefined || !this.project.workNo) {
			Notify({ type: 'danger', message: '获取工作控制号失败' });
		}
		this.user = common.getUser();
		this.photoType = common.getItem("photoType");
		if (this.photoType == "1") {
			this.title = "质量照片上传";
		} else if (this.photoType == "2") {
			this.title = "进度照片上传";
		} else {
			Notify({ type: 'danger', message: '参数错误：未设置照片类型' });
		}
		this.date = getNowDate();
	},
	methods: {
		goBack() {
			this.$router.push({
				name: 'photoList'
			});
		},
		// 标的物
		doGetSubjectDropDown() {
			console.log(this.project.workNo)
			getSubjectDropDown(this.project.workNo).then(response => {
				this.subjectMatterList = response.data.body
			})
		},
		// 专业
		doGetMajorDropDown() {
			console.log(this.project.workNo)
			getMajorList(this.project.workNo).then(response => {
				this.majorMatterList = response.data.body
			})
		},
		selSubjectMatter(data) {
			this.subjectMatter = data.displayName;
			this.subjectMatterId = data.displayValue;
			this.showSubjectMatterPicker = false;
		},
		selMajorMatter(data) {
			this.majorMatter = data.displayName;
			this.majorMatterId = data.displayValue;
			this.showMajorMatterPicker = false;
		},
		selDateCalendar(date) {
			this.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showDateCalendar = false;
		},
		async uploadFile(file) {
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();
			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const fileInfo = {
						filePath: response.data.body.fileSavePath,
						fileUri: response.data.body.fileUri,
						thumbnail : response.data.body.thumbnailPath,
						fileName : response.data.body.fileName,
						fileContent: ''
					};
					this.fileInfoList.push(fileInfo);
				} else {
					Notify({ type: 'danger', message: response.data.resultMessage });
				}
			})
		},
		delFile(file) {
			return new Promise((resolve, reject) => {
				this.fileInfoList.splice(0, 1);
				resolve()
			})
		},
		onSubmit(data) {
			if (!common.hasPermision("qualityProgressPhoto:add:" + this.photoType)) {
				Notify({ type: 'danger', message: "无操作权限" });
				return;
			}
			if (this.fileInfoList == null | this.fileInfoList.length == 0) {
				Notify({ type: 'danger', message: '未上传图片' });
				return;
			}
			this.fileInfoList[0].fileContent = this.photoContent
			const param = {
				workNo: this.project.workNo,
				photoType: this.photoType,
				subjectNo: this.subjectMatterId,
				major: this.majorMatterId,
				photoFilePathList: this.fileInfoList,
				registerTime: this.date,
				registerMan: this.user.username,
			}
			save(param).then(response => {
				if (response.data.messageCode === "SUCCESS") {
					Notify({ type: 'success', message: '操作成功' });
					this.goBack()
				} else {
					Notify({ type: 'danger', message: response.data.resultMessage });
				}
			})
		},
	}
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/common";

.mainBox {
	height: 100%;
	background-color: #ffffff;
}

.uploadBoxTop {
	padding: 50rem/$size 30rem/$size 10rem/$size 30rem/$size;
}

.uploadBoxBottom {
	padding: 10rem/$size 30rem/$size 50rem/$size 30rem/$size;
}

.photoDesc {
	width: 100%;
	height: 156rem/$size;
	border: 1px solid #eeeeee;
	box-sizing: border-box;
	padding: 10rem/$size 20rem/$size;
}

.saveButton {
	display: block;
	width: 60%;
	margin: 0 auto;
}
</style>